import { http } from "@/store/API";

export const downladFileMixin = {
    methods: {
        downloadPdfFile(fileName, orderId, api) {
            http(`${api}?order_id=${orderId}`, {
                headers: {
                    Authorization: `Bearer ${this.$store.state.user.token}`,
                },
            }).then((blob) => {
                setTimeout(() => {
                    let url = "data:application/pdf;base64," + blob.data.data;
                    fetch(url)
                        .then((res) => res.blob())
                        .then((blob) => {
                            let a = window.document.createElement("a");
                            a.href = window.URL.createObjectURL(blob, {
                                type: "application/pdf",
                            });
                            a.download = fileName;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        });

                    // let url = "data:application/pdf;base64," + blob.data.data;
                    // let a = document.createElement("a");
                    // a.href = url;
                    // a.download = fileName;
                    // document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    // a.click();
                    // a.remove(); //afterwards we remove the element again
                }, 500);
            });
        },
    },
};
